<sirius-section class="form-content-layout">
  <sirius-grid>
    @if (contentImage()) {
      <matchmaking-form-image [image]="contentImage()" />
    }
    <div class="content">
      <ng-content />
    </div>
  </sirius-grid>
</sirius-section>
